<div class="p-4">
  <h1>Search Result</h1>
  <div class="divider"></div>
  <h1 class="popup-title ">
    Found {{ searchItem }} results for <b>{{ title }}</b>
  </h1>
</div>
<div class="pos-rel">
  <div class="p-4 top-zero">
    <div class="row" *ngIf="searchItem > 0">
      <div class="col-12" *ngFor="let item of displaySearch">
        <a href="{{ item.url }}" class="action" _target="blank">{{ item.word }}</a>
        <p>{{ item.detail }}</p>
      </div>
    </div>
    <div class="row" *ngIf="searchItem === 0">
      <div class="col-12">
        <p>Sorry no result found</p>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="cta wcf-button d-flex justify-content-end p-4">
    <button blocx-button (click)="close()" [variant]="'outline-primary'" type="button">Close</button>
  </div>
</div>
